module.exports = __webpack_public_path__ + "img/gxnhjcl.d683a85.png";